import { api } from './client';

export type PlanType = 'FREE' | 'PREMIUM' | 'COURTESY' | 'LIFE_PARTNER';
export type MemberRole = 'OWNER' | 'ADMIN' | 'MEMBER';

export interface HouseholdMember {
  id: string;
  userId: string;
  name: string;
  email: string;
  role: MemberRole;
  joinedAt: string;
}

export interface Household {
  id: string;
  name: string;
  plan: PlanType;
  premiumUntil: string | null;
  ownerId: string;
  members: HouseholdMember[];
  inviteToken: string | null;
}

export interface CreateHouseholdPayload {
  householdName: string;
  userName: string;
}

export interface AcceptInvitePayload {
  token: string;
}

export interface InviteTokenResponse {
  token: string;
  inviteUrl: string;
  expiresAt: string;
}

export interface HouseholdInviteInfo {
  householdName: string;
  ownerName: string;
}

export interface HouseholdSummary {
  id: string;
  name: string;
  role: 'OWNER' | 'MEMBER';
  plan: PlanType;
  planUntil: string | null;
  frozenAt: string | null;
}

export const householdApi = {
  list: () => api.get<{ households: HouseholdSummary[] }>('/households'),

  get: () => api.get<Household>('/household'),

  create: (payload: CreateHouseholdPayload) =>
    api.post<Household>('/households', payload),

  update: (data: Partial<Pick<Household, 'name'>>) =>
    api.patch<Household>('/household', data),

  generateInvite: () => api.post<InviteTokenResponse>('/household/invite'),

  acceptInvite: (payload: AcceptInvitePayload) =>
    api.post<Household>('/invite/accept', payload),

  getInviteInfo: (token: string) =>
    api.get<HouseholdInviteInfo>(`/invite/${token}`),

  removeMember: (memberId: string) =>
    api.delete<void>(`/household/members/${memberId}`),

  updateMyName: (name: string) =>
    api.patch<{ id: string; name: string }>('/household/member/me', { name }),
};
